import { forwardRef, type Ref, type SVGProps } from "react";
const IconCameraGridFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M11.98 12.01h7.98v7.98h-7.98zm-9.98 0h7.98v7.98H2zm9.98 9.98h7.98V30h-7.98zM28 2h-6v8h8V4a2 2 0 0 0-2-2M2 28a2 2 0 0 0 2 2h6v-8H2Zm20 2h6a2 2 0 0 0 2-2v-6h-8ZM2 4v6h8V2H4a2 2 0 0 0-2 2m9.98-2h7.98v8.01h-7.98zm9.98 10.01H30v7.98h-8.04z" /></svg>;
const ForwardRef = forwardRef(IconCameraGridFilledSVG);
ForwardRef.displayName = "IconCameraGridFilled";
export { ForwardRef as IconCameraGridFilled };